export const environment = {
    backendUrl: 'https://wiki-islam-backend.kfm.digital/'
}
